import { render } from "./QuestionEditor.vue?vue&type=template&id=249166d8"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"

import "./QuestionEditor.vue?vue&type=style&index=0&id=249166d8&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__